import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  fr: {
    // Nav
    nav_home: 'Accueil',
    nav_catalog: 'Catalogue',
    nav_advantages: 'Avantages Pro',
    nav_about: 'A propos',
    nav_contact: 'Contact',
    nav_login: 'Connexion',
    nav_register: 'Créer un compte Pro',
    nav_pro_space: 'Espace Pro',
    nav_logout: 'Déconnexion',
    nav_my_orders: 'Mes Commandes',
    nav_account: 'Mon compte',
    // Hero
    hero_subtitle: 'Distribution B2B — Belgique & Benelux',
    hero_title_1: "Les saveurs",
    hero_title_2: "d'Amérique latine",
    hero_title_3: "pour les pros",
    hero_desc: "Importation et distribution de produits alimentaires latino-américains dans tout le Benelux.",
    hero_cta_catalog: 'Voir le catalogue',
    hero_cta_advantages: 'Découvrez tous nos avantages PRO',
    // Value props
    vp_order: 'Commande simplifiée', vp_order_desc: 'En quelques clics',
    vp_delivery: 'Livraison rapide', vp_delivery_desc: 'Dans tout le Benelux',
    vp_payment: 'Facilité de paiement', vp_payment_desc: "Vendez d'abord, payez ensuite",
    vp_contact: 'Contact privilégié', vp_contact_desc: 'Ligne dédiée',
    // Categories
    cat_title_sub: 'Nos rayons',
    cat_title: 'Explorez nos catégories',
    cat_see_all: 'Tout voir',
    cat_product: 'produit', cat_products: 'produits',
    // Featured
    feat_sub: 'Sélection', feat_title: 'Produits populaires',
    feat_login_price: 'Connectez-vous pour le prix pro',
    // Truck section
    truck_sub: 'Livraison professionnelle',
    truck_title: 'Nous livrons les professionnels du Benelux',
    truck_desc: 'Amazonia livre directement sur votre lieu de travail avec des tarifs et conditions avantageuses.',
    truck_cta: 'Découvrez tous nos avantages PRO',
    truck_clients: 'Magasins, restauration, traiteurs et stands festival.',
    // Catalog page
    catalog_title: 'Catalogue', catalog_all: 'Tous les produits',
    catalog_search: 'Rechercher...', catalog_categories: 'Catégories',
    catalog_no_product: 'Aucun produit trouvé', catalog_filters: 'Filtres',
    // Product detail
    product_public_price: 'Prix public', product_pro_price: 'Prix professionnel',
    product_login_pro: 'Connectez-vous pour voir votre prix professionnel',
    product_delivery: 'Délai de livraison', product_add_cart: 'Ajouter au panier',
    product_adding: 'Ajout...', product_login_order: 'Connectez-vous pour commander',
    product_login_link: 'Se connecter', product_or: 'ou', product_register_link: 'Créer un compte',
    product_not_found: 'Produit non trouvé', product_back: 'Retour au catalogue',
    // Cart
    cart_title: 'Panier', cart_empty: 'Votre panier est vide',
    cart_total: 'Total', cart_checkout: 'Passer la commande',
    cart_pro_required: 'Compte professionnel validé requis pour commander',
    cart_clear: 'Vider le panier',
    cart_deposit: "Acompte commande (10%)", cart_delivery_pay: "A la livraison (10%)",
    cart_balance: "Solde à 30 jours (80%)",
    // About
    about_sub: 'A propos', about_title: 'AMAZONIA.FOOD',
    about_partner: 'Votre partenaire en produits latino-américains',
    about_desc_1: "Importation et distribution de produits alimentaires latino-américains dans tout le Benelux.",
    about_desc_2: "Nous connectons les professionnels de la restauration, du commerce et de l'événementiel aux meilleures saveurs d'Amérique latine.",
    about_desc_3: "Avec un catalogue de plus de 190 références soigneusement sélectionnées, nous proposons des produits authentiques allant des empanadas aux boissons tropicales, en passant par les épices, farines et snacks.",
    about_hq: 'Siège social', about_manager: 'Gérante', about_phone: 'Téléphone',
    about_email: 'Email', about_website: 'Site web',
    about_legal: "AMAZONIA.FOOD est une marque d'Elite Lead SRL",
    about_references: 'Références', about_pro_service: 'Service professionnel', about_delivery_zone: 'Zone de livraison',
    // Contact
    contact_sub: 'Contact', contact_title: 'Contactez-nous',
    contact_name: 'Nom', contact_email: 'Email', contact_phone: 'Téléphone',
    contact_message: 'Message', contact_send: 'Envoyer le message', contact_sending: 'Envoi...',
    contact_sent_title: 'Message envoyé !', contact_sent_desc: 'Nous vous répondrons dans les plus brefs délais.',
    contact_address: 'Adresse',
    // Login
    login_title: 'Connexion', login_desc: 'Accédez à votre espace professionnel',
    login_submit: 'Se connecter', login_loading: 'Connexion...',
    login_no_account: 'Pas encore de compte ?',
    // Register
    register_title: 'Créer un compte Pro', register_desc: 'Accédez aux prix professionnels et commandez en ligne',
    register_company: "Nom de l'entreprise", register_vat: 'Numéro de TVA',
    register_password: 'Mot de passe', register_confirm: 'Confirmer le mot de passe',
    register_submit: 'Créer mon compte', register_loading: 'Inscription...',
    register_has_account: 'Déjà un compte ?', register_login: 'Se connecter',
    register_success_title: 'Candidature enregistrée !',
    register_success_desc: 'Votre candidature est en cours de validation. Réservez votre premier rendez-vous commercial pour activer votre compte.',
    register_success_calendly: 'Prendre rendez-vous',
    register_success_browse: 'Parcourir le catalogue en attendant',
    // Footer
    footer_tagline: "Importation et distribution de produits alimentaires latino-américains dans tout le Benelux.",
    footer_nav: 'Navigation', footer_account: 'Compte', footer_contact: 'Contact',
    footer_legal: "AMAZONIA.FOOD est une marque d'Elite Lead SRL",
    footer_rights: 'Tous droits réservés',
    footer_manager: 'Gérante: Désirée Malpica',
    // WhatsApp
    wa_greeting: 'Bonjour ! Comment pouvons-nous vous aider ?',
    wa_placeholder: 'Écrivez votre message...',
    // General
    eur: 'EUR', pro: 'Pro',
    download_catalog: 'Télécharger le catalogue PDF',
  },
  es: {
    nav_home: 'Inicio', nav_catalog: 'Catálogo', nav_advantages: 'Ventajas Pro',
    nav_about: 'Acerca de', nav_contact: 'Contacto', nav_login: 'Iniciar sesión',
    nav_register: 'Crear cuenta Pro', nav_pro_space: 'Espacio Pro', nav_logout: 'Cerrar sesión',
    nav_my_orders: 'Mis Pedidos', nav_account: 'Mi cuenta',
    hero_subtitle: 'Distribución B2B — Bélgica & Benelux',
    hero_title_1: "Los sabores", hero_title_2: "de América Latina", hero_title_3: "para profesionales",
    hero_desc: "Importación y distribución de productos alimenticios latinoamericanos en todo el Benelux.",
    hero_cta_catalog: 'Ver el catálogo', hero_cta_advantages: 'Descubra todas nuestras ventajas PRO',
    vp_order: 'Pedido simplificado', vp_order_desc: 'En pocos clics',
    vp_delivery: 'Entrega rápida', vp_delivery_desc: 'En todo el Benelux',
    vp_payment: 'Facilidad de pago', vp_payment_desc: 'Venda primero, pague después',
    vp_contact: 'Contacto privilegiado', vp_contact_desc: 'Línea dedicada',
    cat_title_sub: 'Nuestras secciones', cat_title: 'Explore nuestras categorías',
    cat_see_all: 'Ver todo', cat_product: 'producto', cat_products: 'productos',
    feat_sub: 'Selección', feat_title: 'Productos populares',
    feat_login_price: 'Inicie sesión para ver el precio profesional',
    truck_sub: 'Entrega profesional', truck_title: 'Entregamos a profesionales del Benelux',
    truck_desc: 'Amazonia entrega directamente en su lugar de trabajo con tarifas y condiciones ventajosas.',
    truck_cta: 'Descubra todas nuestras ventajas PRO',
    truck_clients: 'Tiendas, restauración, catering y stands de festivales.',
    catalog_title: 'Catálogo', catalog_all: 'Todos los productos',
    catalog_search: 'Buscar...', catalog_categories: 'Categorías',
    catalog_no_product: 'Ningún producto encontrado', catalog_filters: 'Filtros',
    product_public_price: 'Precio público', product_pro_price: 'Precio profesional',
    product_login_pro: 'Inicie sesión para ver su precio profesional',
    product_delivery: 'Plazo de entrega', product_add_cart: 'Añadir al carrito',
    product_adding: 'Añadiendo...', product_login_order: 'Inicie sesión para pedir',
    product_login_link: 'Iniciar sesión', product_or: 'o', product_register_link: 'Crear una cuenta',
    product_not_found: 'Producto no encontrado', product_back: 'Volver al catálogo',
    cart_title: 'Carrito', cart_empty: 'Su carrito está vacío',
    cart_total: 'Total', cart_checkout: 'Realizar pedido',
    cart_pro_required: 'Se requiere una cuenta profesional validada para pedir',
    cart_clear: 'Vaciar carrito',
    cart_deposit: 'Anticipo pedido (10%)', cart_delivery_pay: 'En la entrega (10%)', cart_balance: 'Saldo a 30 días (80%)',
    about_sub: 'Acerca de', about_title: 'AMAZONIA.FOOD',
    about_partner: 'Su socio en productos latinoamericanos',
    about_desc_1: "Importación y distribución de productos alimenticios latinoamericanos en todo el Benelux.",
    about_desc_2: "Conectamos a los profesionales de la restauración, el comercio y los eventos con los mejores sabores de América Latina.",
    about_desc_3: "Con un catálogo de más de 190 referencias cuidadosamente seleccionadas, ofrecemos productos auténticos.",
    about_hq: 'Sede social', about_manager: 'Gerente', about_phone: 'Teléfono',
    about_email: 'Correo', about_website: 'Sitio web',
    about_legal: 'AMAZONIA.FOOD es una marca de Elite Lead SRL',
    about_references: 'Referencias', about_pro_service: 'Servicio profesional', about_delivery_zone: 'Zona de entrega',
    contact_sub: 'Contacto', contact_title: 'Contáctenos',
    contact_name: 'Nombre', contact_email: 'Correo', contact_phone: 'Teléfono',
    contact_message: 'Mensaje', contact_send: 'Enviar mensaje', contact_sending: 'Enviando...',
    contact_sent_title: '¡Mensaje enviado!', contact_sent_desc: 'Le responderemos lo antes posible.',
    contact_address: 'Dirección',
    login_title: 'Iniciar sesión', login_desc: 'Acceda a su espacio profesional',
    login_submit: 'Iniciar sesión', login_loading: 'Conectando...',
    login_no_account: '¿Aún no tiene cuenta?',
    register_title: 'Crear cuenta Pro', register_desc: 'Acceda a precios profesionales y pida en línea',
    register_company: 'Nombre de la empresa', register_vat: 'Número de IVA',
    register_password: 'Contraseña', register_confirm: 'Confirmar contraseña',
    register_submit: 'Crear mi cuenta', register_loading: 'Registrando...',
    register_has_account: '¿Ya tiene cuenta?', register_login: 'Iniciar sesión',
    register_success_title: '¡Solicitud registrada!',
    register_success_desc: 'Su solicitud está en proceso de validación. Reserve su primera cita comercial.',
    register_success_calendly: 'Reservar cita', register_success_browse: 'Explorar el catálogo mientras tanto',
    footer_tagline: "Importación y distribución de productos alimenticios latinoamericanos en todo el Benelux.",
    footer_nav: 'Navegación', footer_account: 'Cuenta', footer_contact: 'Contacto',
    footer_legal: 'AMAZONIA.FOOD es una marca de Elite Lead SRL',
    footer_rights: 'Todos los derechos reservados', footer_manager: 'Gerente: Désirée Malpica',
    wa_greeting: '¡Hola! ¿Cómo podemos ayudarle?', wa_placeholder: 'Escriba su mensaje...',
    eur: 'EUR', pro: 'Pro', download_catalog: 'Descargar catálogo PDF',
  },
  en: {
    nav_home: 'Home', nav_catalog: 'Catalog', nav_advantages: 'Pro Benefits',
    nav_about: 'About', nav_contact: 'Contact', nav_login: 'Sign in',
    nav_register: 'Create Pro Account', nav_pro_space: 'Pro Space', nav_logout: 'Sign out',
    nav_my_orders: 'My Orders', nav_account: 'My Account',
    hero_subtitle: 'B2B Distribution — Belgium & Benelux',
    hero_title_1: "The flavors", hero_title_2: "of Latin America", hero_title_3: "for professionals",
    hero_desc: "Import and distribution of Latin American food products throughout the Benelux.",
    hero_cta_catalog: 'Browse catalog', hero_cta_advantages: 'Discover all our PRO benefits',
    vp_order: 'Easy ordering', vp_order_desc: 'In a few clicks',
    vp_delivery: 'Fast delivery', vp_delivery_desc: 'Across the Benelux',
    vp_payment: 'Easy payment', vp_payment_desc: 'Sell first, pay later',
    vp_contact: 'Dedicated contact', vp_contact_desc: 'Direct line',
    cat_title_sub: 'Our sections', cat_title: 'Explore our categories',
    cat_see_all: 'See all', cat_product: 'product', cat_products: 'products',
    feat_sub: 'Selection', feat_title: 'Popular products',
    feat_login_price: 'Log in for professional pricing',
    truck_sub: 'Professional delivery', truck_title: 'We deliver to Benelux professionals',
    truck_desc: 'Amazonia delivers directly to your workplace with competitive rates and terms.',
    truck_cta: 'Discover all our PRO benefits',
    truck_clients: 'Shops, restaurants, caterers and festival stands.',
    catalog_title: 'Catalog', catalog_all: 'All products',
    catalog_search: 'Search...', catalog_categories: 'Categories',
    catalog_no_product: 'No products found', catalog_filters: 'Filters',
    product_public_price: 'Public price', product_pro_price: 'Professional price',
    product_login_pro: 'Log in to see your professional price',
    product_delivery: 'Delivery time', product_add_cart: 'Add to cart',
    product_adding: 'Adding...', product_login_order: 'Log in to order',
    product_login_link: 'Sign in', product_or: 'or', product_register_link: 'Create account',
    product_not_found: 'Product not found', product_back: 'Back to catalog',
    cart_title: 'Cart', cart_empty: 'Your cart is empty',
    cart_total: 'Total', cart_checkout: 'Place order',
    cart_pro_required: 'Validated professional account required to order',
    cart_clear: 'Clear cart',
    cart_deposit: 'Order deposit (10%)', cart_delivery_pay: 'On delivery (10%)', cart_balance: 'Balance at 30 days (80%)',
    about_sub: 'About', about_title: 'AMAZONIA.FOOD',
    about_partner: 'Your partner in Latin American products',
    about_desc_1: "Import and distribution of Latin American food products throughout the Benelux.",
    about_desc_2: "We connect restaurant, retail and event professionals with the best flavors of Latin America.",
    about_desc_3: "With a catalog of over 190 carefully selected references, we offer authentic products.",
    about_hq: 'Headquarters', about_manager: 'Manager', about_phone: 'Phone',
    about_email: 'Email', about_website: 'Website',
    about_legal: 'AMAZONIA.FOOD is a brand of Elite Lead SRL',
    about_references: 'References', about_pro_service: 'Professional service', about_delivery_zone: 'Delivery zone',
    contact_sub: 'Contact', contact_title: 'Contact us',
    contact_name: 'Name', contact_email: 'Email', contact_phone: 'Phone',
    contact_message: 'Message', contact_send: 'Send message', contact_sending: 'Sending...',
    contact_sent_title: 'Message sent!', contact_sent_desc: 'We will get back to you as soon as possible.',
    contact_address: 'Address',
    login_title: 'Sign in', login_desc: 'Access your professional space',
    login_submit: 'Sign in', login_loading: 'Signing in...',
    login_no_account: "Don't have an account yet?",
    register_title: 'Create Pro Account', register_desc: 'Access professional pricing and order online',
    register_company: 'Company name', register_vat: 'VAT number',
    register_password: 'Password', register_confirm: 'Confirm password',
    register_submit: 'Create my account', register_loading: 'Registering...',
    register_has_account: 'Already have an account?', register_login: 'Sign in',
    register_success_title: 'Application registered!',
    register_success_desc: 'Your application is being reviewed. Book your first commercial meeting to activate your account.',
    register_success_calendly: 'Book appointment', register_success_browse: 'Browse the catalog in the meantime',
    footer_tagline: "Import and distribution of Latin American food products throughout the Benelux.",
    footer_nav: 'Navigation', footer_account: 'Account', footer_contact: 'Contact',
    footer_legal: 'AMAZONIA.FOOD is a brand of Elite Lead SRL',
    footer_rights: 'All rights reserved', footer_manager: 'Manager: Désirée Malpica',
    wa_greeting: 'Hello! How can we help you?', wa_placeholder: 'Write your message...',
    eur: 'EUR', pro: 'Pro', download_catalog: 'Download PDF catalog',
  }
};

const FLAGS = { fr: '\u{1F1EB}\u{1F1F7}', es: '\u{1F1EA}\u{1F1F8}', en: '\u{1F1EC}\u{1F1E7}' };
const LANG_NAMES = { fr: 'FR', es: 'ES', en: 'EN' };

const I18nContext = createContext(null);

function detectLanguage() {
  const saved = localStorage.getItem('amazonia_lang');
  if (saved && translations[saved]) return saved;
  const browserLang = (navigator.language || navigator.userLanguage || 'fr').slice(0, 2).toLowerCase();
  if (translations[browserLang]) return browserLang;
  return 'fr';
}

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(detectLanguage);

  const changeLang = (newLang) => {
    if (translations[newLang]) {
      setLang(newLang);
      localStorage.setItem('amazonia_lang', newLang);
    }
  };

  const t = (key) => translations[lang]?.[key] || translations.fr[key] || key;

  return (
    <I18nContext.Provider value={{ lang, changeLang, t, FLAGS, LANG_NAMES }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used within I18nProvider');
  return ctx;
}
